import NoteContext from "./NoteContext.js";
import { useState } from "react";

const NoteState = (props) => {
  const host = props.URI;

  const noteInitials = []

  const [note, setnote] = useState(noteInitials)
  const [user, setUser] = useState([])
  const [mode, setMode] = useState({ backgroundColor: "#77737a" })
  const [textColor, settextColor] = useState({ color: "black" })
  const [backgroundColor, setBackgroundColor] = useState({ backgroundColor: "lavenderblush" })

  //Fetch Note
  const fetchNote = async () => {
    const response = await fetch(`${host}/api/notes/fetchAllNote`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "auth-token": localStorage.getItem("token"),
      },
    });
    const json = await response.json();
    // console.log(json);
    setnote(json);
  }

  //AddNote
  const addNote = async (title, description, tag) => {
    const response = await fetch(`${host}/api/notes/addnote`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "auth-token": localStorage.getItem("token"),
      },
      body: JSON.stringify({ title, description, tag }),
    });
    const newNote = await response.json();
    setnote(note.concat(newNote));
    // console.log(newNote)
  };

  //DeleteNote
  const deleteNote = async (_id) => {
    const isConfirmed = window.confirm("Are you sure you want to delete this Note?");
    if (!isConfirmed) {
      return;
    }

    const response = await fetch(`${host}/api/notes/deleteNote/${_id}`, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        "auth-token": localStorage.getItem("token"),
      },
    });

    console.log("Note Deleted");
    setnote(note.filter((note) => note._id !== _id));

    const json = await response.json();
    props.showAlert("success", "Note Deleted Successfully");
    // console.log(json);
  }

  //Delete User
  const deleteUser = async (_id) => {
    const response = await fetch(`${host}/api/auth/deleteUser/${_id}`, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        "auth-token": localStorage.getItem("token"),
      },
    });

    console.log("User Deleted");
    setUser(user.filter((user) => user._id !== _id));

    const json = await response.json();
    // console.log(json);
  }

  //EditNote
  const editNote = async (_id, title, description, tag) => {

    const response = await fetch(`${host}/api/notes/updateNote/${_id}`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        "auth-token": localStorage.getItem("token"),
      },
      body: JSON.stringify({ title, description, tag }),
    });
    const json = await response.json();
    // console.log(json);

    let newNotes = JSON.parse(JSON.stringify(note))
    for (let i = 0; i < newNotes.length; i++) {
      const element = newNotes[i];
      if (element._id === _id) {
        newNotes[i].title = title;
        newNotes[i].description = description;
        newNotes[i].tag = tag;
        break;
      }
    }
    console.log("Edit Note")
    setnote(newNotes)
  }

  return (
    <NoteContext.Provider value={{ note, addNote, deleteNote, editNote, fetchNote, deleteUser, mode, setMode, textColor, settextColor, backgroundColor, setBackgroundColor }}>
      {props.children}
    </NoteContext.Provider>
  )
}

export default NoteState;